import { StyledSubTitle, StyledText } from '@selfserve/react-ui';
import { getPlanListStatusIndicators } from '@selfserve/react-utils';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { PlanItemInfo } from '../data';
import {
  MenuButton,
  StyledInfoContainer,
  StyledItemContainer,
  StyledStatusContainer,
} from '../feature/plans-overview';

interface Props {
  plans: Array<PlanItemInfo>;
  open: boolean;
  selectedId: string;
  handleMenuClick: (
    isAddIn: boolean,
    name: string
  ) => (event: MouseEvent<HTMLButtonElement>) => void;
  handleGoToApp: (id: string) => () => void;
}

export const PlansList = ({
  plans,
  open,
  selectedId,
  handleMenuClick,
  handleGoToApp,
}: Props) => {
  const { t } = useTranslation();
  return (
    <StyledInfoContainer className="plan-list">
      <StyledSubTitle>{t('common.your-plan')}</StyledSubTitle>
      {plans?.length ? (
        plans.map((planItem) => {
          const { showStatus, isPending } = getPlanListStatusIndicators(
            planItem.status
          );
          return (
            <StyledItemContainer key={planItem?.id}>
              <div className="overview-information-value">
                <StyledText
                  as="span"
                  className="overview-information-label"
                  onClick={handleGoToApp(planItem?.id as string)}
                  isCursorPointer
                  bold
                  flex
                >
                  {planItem?.plan?.displayName}
                </StyledText>
                <StyledText as="span">
                  {planItem?.planPresentationInfo}
                </StyledText>
              </div>
              {showStatus && (
                <StyledStatusContainer status={planItem.status as string}>
                  <span>{t(`subscription-status.${planItem.status}`)}</span>
                  {isPending && <p>{t('common.on-hold-text')}</p>}
                </StyledStatusContainer>
              )}
              <MenuButton
                open={open && selectedId === planItem.id}
                onClick={handleMenuClick(false, planItem?.id as string)}
              />
            </StyledItemContainer>
          );
        })
      ) : (
        <StyledText>{t('common.no-plans')}</StyledText>
      )}
    </StyledInfoContainer>
  );
};
